<template>
  <div class="bar">
    <bar-chart
      ref="chart"
      :chart-data="chartData"
      :options="chartOptions"
      :height="height"
      :width="width"
      :plugins="plugins"
    />
  </div>
</template>
<script>
import { BarChart } from 'vue-chart-3'

export default {
  components: { BarChart },
  props: {
    chartData: {
      type: Object,
      default: () => ({}),
    },
    chartOptions: {
      type: Object,
      default: () => ({}),
    },
    height: {
      type: Number,
      default: undefined,
    },
    width: {
      type: Number,
      default: undefined,
    },
    plugins: {
      type: Array,
      required: true,
    },
  },
}
</script>
<style scoped>
.bar {
  position: relative;
}
</style>
